import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import WhatsAppChat from "../WhatsAppChat";

import bulkorder from "../../images/bulkorder.png"

// Fruits Images
import mango from "../../images/fruits/Mango.png";
import apple from "../../images/fruits/Apple.png";
import Grapes from "../../images/fruits/Green Grapes.jpeg";
import Pomegranate from "../../images/fruits/Pomegranate.jpeg";
import Orange from "../../images/fruits/Orange.jpeg";
import Banana from "../../images/fruits/Bananas.jpeg";
import Guava from "../../images/fruits/Guava.jpeg";
import Lemon from "../../images/fruits/Lemon.jpeg";
import DragonFruit from "../../images/fruits/Dragon Fruit.jpeg";
import Pineapple from "../../images/fruits/Pineapple.jpeg";
import papaya from "../../images/fruits/papaya.jpeg";
import Strawberries from "../../images/fruits/Strawberries.jpeg";
import Avocado from "../../images/fruits/Avocado.jpeg";
import Kiwi from "../../images/fruits/Kiwi.jpeg";
import Amla from "../../images/fruits/amla.jpeg";


// Vegetables Images
import Cauliflower from "../../images/vegetables/Cauliflower.jpeg";
import Garlic from "../../images/vegetables/Garlic.jpeg";
import GreenChili from "../../images/vegetables/Green Chili.jpeg";
import GreenPeas from "../../images/vegetables/Green Peas.jpeg";
import Mushrooms from "../../images/vegetables/Mushrooms.jpeg";
import Spinach from "../../images/vegetables/Spinach.jpeg";
import Tomato from "../../images/vegetables/Tomato.jpeg";
import Capsicum from "../../images/vegetables/Capsicum.jpeg";
import Brinjal from "../../images/vegetables/Brinjal.jpeg";
import GreenBeans from "../../images/vegetables/Green Beans.jpeg";
import BottleGourd from "../../images/vegetables/Bottle Gourd.jpeg";
import Cabbage from "../../images/vegetables/Cabbage.jpeg";
import BitterGourd from "../../images/vegetables/Bitter Gourd.jpeg";
import Potatoes from "../../images/vegetables/Potatoe.jpeg";
import Carrot from "../../images/vegetables/Carrot.jpeg";
import Onion from "../../images/vegetables/Onion.jpeg";
import Corn from "../../images/vegetables/Corn.jpeg";


// Spices Images
import Clove from "../../images/Spices/Clove.jpeg";
import Cardamom from "../../images/Spices/Cardamom.jpeg";
import Nutmeg from "../../images/Spices/Nutmeg.jpeg";
import Fenugreek from "../../images/Spices/Fenugreek.jpeg";
import MustardSeeds from "../../images/Spices/Mustard Seeds.jpeg";
import StarAnise from "../../images/Spices/Star Anise.jpeg";
import Cumin from "../../images/Spices/cumin.jpeg";
import RedChili from "../../images/Spices/red chili.jpeg";
import Turmeric from "../../images/Spices/turmeric.jpeg";
import Coriander from "../../images/Spices/Coriander.jpeg";
import BlackPepper from "../../images/Spices/Black Pepper.jpeg";
import Cinnamon from "../../images/Spices/Cinnamon.jpeg";
import GaramMasala from "../../images/Spices/Garam Masala.jpeg";

const Products = () => {
  const navigate = useNavigate();
  const { category } = useParams();

  const [activeTab, setActiveTab] = useState("Fruits");

  const products = {
    Fruits: [
      { name: "Mango", img: mango },
      { name: "Apple", img: apple },
      { name: "Green Grapes", img: Grapes },
      { name: "Orange", img: Orange },
      { name: "Pomegranate", img: Pomegranate },
      { name: "Banana", img: Banana },
      { name: "Guava", img: Guava },
      { name: "Lemon", img: Lemon },
      { name: "Dragon Fruit", img: DragonFruit },
      { name: "Pineapple", img: Pineapple },
      { name: "papaya", img: papaya },
      { name: "Strawberries", img: Strawberries },
      { name: "Avocado", img: Avocado },
      { name: "Kiwi", img: Kiwi },
      { name: "Amla", img: Amla },

    ],
    Vegetables: [
      { name: "Onion", img: Onion },
      { name: "Corn", img: Corn },
      { name: "Cauliflower", img: Cauliflower },
      { name: "Garlic", img: Garlic },
      { name: "Green Chili", img: GreenChili },
      { name: "Green Peas", img: GreenPeas },
      { name: "Mushrooms", img: Mushrooms },
      { name: "Spinach", img: Spinach },
      { name: "Tomato", img: Tomato },
      { name: "Green Bell Pepper (Capsicum)", img: Capsicum },
      { name: "Brinjal (Eggplant)", img: Brinjal },
      { name: "Green Beans", img: GreenBeans },
      { name: "Bottle Gourd (Lauki)", img: BottleGourd },
      { name: "Cabbage", img: Cabbage },
      { name: "Bitter Gourd (Karela)", img: BitterGourd },
      { name: "Potatoes", img: Potatoes },
      { name: "Carrot", img: Carrot },

    ],
    Spices: [
      { name: "Cardamom", img: Cardamom },
      { name: "Clove", img: Clove },
      { name: "Nutmeg", img: Nutmeg },
      { name: "Fenugreek", img: Fenugreek },
      { name: "Mustard Seeds", img: MustardSeeds },
      { name: "Star Anise", img: StarAnise },
      { name: "Cumin", img: Cumin },
      { name: "Red Chili", img: RedChili },
      { name: "Turmeric", img: Turmeric },
      { name: "Coriander", img: Coriander },
      { name: "Black Pepper", img: BlackPepper },   
      { name: "Cinnamon", img: Cinnamon },   
      { name: "Garam Masala", img: GaramMasala },   
     ],
  };

  // Sync URL → tab
  useEffect(() => {
    if (category) {
      const formatted =
        category.charAt(0).toUpperCase() + category.slice(1);

      if (products[formatted]) {
        setActiveTab(formatted);
      }
    }
  }, [category]);

  return (
    <div className="products-page">
      <h2 className="title">Our Products 🌿</h2>

      {/* TABS */}
      <div className="tabs">
        {Object.keys(products).map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? "tab active" : "tab"}
            onClick={() => {
              setActiveTab(tab);
              navigate(`/products/${tab.toLowerCase()}`);
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* GRID */}
      <div className="grid">
        {products[activeTab].length > 0 ? (
          products[activeTab].map((item, index) => (
            <div key={index} className="card">
              <img
                  src={item.img}
                  alt={item.name}
                  className={activeTab === "Spices" ? "spice-img" : ""}
                />
              <div className="card-body">
                <h3>{item.name}</h3>
              </div>
            </div>
          ))
        ) : (
          <p className="empty">No products available</p>
        )}
      </div>

      {/* BULK */}
      <div className="bulk-section">
        <div className="bulk-content">
          <img src={bulkorder} className="bulkorder" alt="bulkorder" />
          <h3>Looking for Bulk Orders? 🌿</h3>
          <p>
            We supply premium quality products in bulk quantity with best
            packaging and on-time delivery.
          </p>
          <button onClick={() => navigate("/contact")}>Get a Quote</button>
        </div>
      </div>

      <WhatsAppChat />

      {/* CSS */}
      <style>{`
        .products-page {
          padding-top: 90px;
          background: #f8f9fa;
          min-height: 100vh;
        }

        .title {
          font-size: 30px;
          font-weight: 800;
          padding-left: 20px;
          margin-bottom: 20px;

          background: linear-gradient(to right, #14532d, #84cc16);
          -webkit-background-clip: text;
          color: transparent;
        }

        /* TABS */
        .tabs {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-bottom: 30px;
        }

        .tab {
          padding: 8px 18px;
          border-radius: 20px;
          border: none;
          background: #e5e7eb;
          cursor: pointer;
          font-weight: 600;
          transition: 0.3s;
        }

        .tab:hover {
          background: #d1d5db;
        }

        .tab.active {
          background: #14532d;
          color: white;
        }

        /* GRID */
       .grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr); /* desktop */
          gap: 20px;
          padding: 0 20px;
        }

        /* CARD */
        /* CARD */
        .card {
          width: 100%;
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          transition: 0.2s;
          cursor: pointer;
        }

        .card:hover {
          transform: translateY(-6px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }

        .card img {
          width: 100%;
          border-radius: 2px;
          height: 200px;
          object-fit: cover;
        }

        /* 👇 THIS must come AFTER .card img */
        .card img.spice-img {
          height: 250px !important;
        }

        .card-body {
          padding: 8px;
          text-align: center;
        }

        .card-body h3 {
          margin: 0;
          font-size: 16px;
        }

        .card-body span {
          color: #16a34a;
          font-size: 13px;
          font-weight: 600;
        }

        .empty {
          text-align: center;
          color: #666;
        }

        /* BULK */
        .bulk-section {
          margin: 20px 20px;
          border-radius: 20px;
          background: linear-gradient(to right, #14532d, #4d7c0f);
          color: white;
          padding: 20px 20px;
          display: flex;
          justify-content: center;
        }

        .bulk-content {
          max-width: 900px;
          display: flex;
          align-items: center;
          gap: 30px;
          flex-wrap: wrap; /* responsive */
        }

        /* IMAGE */
        .bulkorder {
          width: 280px;
          max-width: 100%;
          height: auto;
          // border-radius: 16px;
          // background: white;
          // padding: 10px;
          // box-shadow: 0 8px 20px rgba(0,0,0,0.2);
        }

        /* TEXT */
        .bulk-content h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .bulk-content p {
          font-size: 15px;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        /* BUTTON */
        .bulk-content button {
          background: #84cc16;
          border: none;
          padding: 10px 20px;
          border-radius: 25px;
          cursor: pointer;
          font-weight: bold;
          transition: 0.3s;
        }

        .bulk-content button:hover {
          background: #a3e635;
          transform: scale(1.05);
        }
        @media (max-width: 768px) {
          .bulk-content {
            flex-direction: column;
            text-align: center;
          }

          .bulkorder {
            width: 220px;
          }
        }
             /* Tablet */
       /* Desktop large screens */
        @media (min-width: 1200px) {
          .grid {
            grid-template-columns: repeat(6, 1fr); /* 👈 6 cards */
          }
        }
          /* Mobile → 2 per row */
        @media (max-width: 768px) {
        .grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 12px; /* spacing */
        }

        .card img {
        // width:170px;
          height: 160px; /* adjust image inside */
        }
      }
      `}</style>
    </div>
  );
};

export default Products;